import { deleteAsync, getAsync, patchAsync, postAsync, putAsync } from '../api.service'
import { queryString } from '../sso-workspace/auth-api'

// Direct calls to rapid-api-content's /api/ddd for pages whose query string
// is built per request (filters, paging cursors) -- the content twin of
// sso-workspace/auth-api. Each resolves to the body; on failure it throws
// the response ({ status, data }) so serverMessage(err) reads data.message.
const base = () => process.env.REACT_APP_API_CONTENT

const unwrap = async call => {
  try {
    const result = await call()
    return result ? result.data : undefined
  } catch (err) {
    throw (err && err.response) || err
  }
}

export const contentGet = (path, params) => unwrap(() => getAsync(base(), `api/ddd/${path}${queryString(params)}`))
export const contentPost = (path, body) => unwrap(() => postAsync(base(), `api/ddd/${path}`, body))
export const contentPut = (path, body) => unwrap(() => putAsync(base(), `api/ddd/${path}`, body))
export const contentPatch = (path, body) => unwrap(() => patchAsync(base(), `api/ddd/${path}`, body))
// body: an optional JSON body (a revoke's reason).
export const contentDelete = (path, params, body) => unwrap(() => deleteAsync(base(), `api/ddd/${path}${queryString(params)}`, body))
